<template>
  <div>
    <div class="cui__utils__heading">
      <strong>Контент: Страницы сайта</strong>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">Страница авто</h5>
        </div>
      </div>
      <div class="card-body">
        <auto-blocks-table-settings :list="list" @getList="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import AutoBlocksTableSettings from '@/components/content/pages/auto/AutoBlocksTableSettings'

export default {
  name: 'index',
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.list = (await this.$services.get('admin/blocks')).data.data.values
      } catch (e) {
        console.log(e)
      }
    },
  },
  components: { AutoBlocksTableSettings },
}
</script>

<style scoped>

</style>
